import isArcGisLayer from './isArcGisLayer'
import axios from 'axios'

const GeoServerWfsQuery = map => {
  const geoserverWfsQuery = options => {
    let cql_filter =
      'BBOX(the_geom, ' +
      options.extent.join(',') +
      ",'" +
      options.srsName +
      "'" +
      ')' // eslint-disable-line

    if (options.cql_filter) {
      cql_filter += ' AND ' + options.cql_filter // eslint-disable-line
    }

    var url = options.baseUrl || 'https://olgatest.scaskog.com/ows/wfs'

    var params = {
      SERVICE: 'WFS',
      VERSION: '2.0.0',
      REQUEST: 'GetFeature',
      TYPENAME: options.featureType,
      OUTPUTFORMAT: 'application/json',
      CQL_FILTER: cql_filter,
      SRSNAME: options.srsName
    }

    if (options.layer.metadata && options.layer.metadata.count) {
      params.COUNT = options.layer.metadata.count
    }

    if (options.viewparams) {
      params.VIEWPARAMS = options.viewparams
    }

    if (options.access_token) {
      params.access_token = options.access_token
    }

    return axios.get(url, { params }).then(response => response.data)
  }

  const query = (layer, queryOptions) => {
    const srsName = map
      .getView()
      .getProjection()
      .getCode()
    return geoserverWfsQuery({
      baseUrl: layer.metadata.baseUrl,
      featureType: layer.metadata.featureType,
      viewparams: layer.source.params.viewparams,
      srsName: srsName,
      layer: layer,
      cql_filter:
        layer.source.params.CQL_FILTER || layer.source.params.cql_filter,
      extent: queryOptions.extent,
      access_token: layer.source.params.access_token
    }).catch(err => {
      console.error('GeoServerWfsQuery: Failed to query', layer.name, err)
      return []
    })
  }

  const isLayerSupported = layer =>
    !isArcGisLayer(layer) &&
    (layer.source.type === 'TileWMS' || layer.source.type === 'ImageWMS')

  return {
    query,
    isLayerSupported
  }
}

export default GeoServerWfsQuery
